import { useState } from "react";
import { X } from "lucide-react";

const WHATSAPP_NUMBER = "919963756669";
const DEFAULT_MESSAGE = "Hi, I'm interested in learning more about the courses offered at Vainavi Educational Institutions.";

export default function WhatsAppButton() {
  const [tooltip, setTooltip] = useState(false);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3" data-testid="whatsapp-widget">
      {/* Tooltip */}
      {tooltip && (
        <div
          data-testid="whatsapp-tooltip"
          className="bg-white shadow-xl border border-slate-200 p-4 max-w-[260px] animate-fade-in-up"
        >
          <div className="flex items-start justify-between gap-2 mb-2">
            <p className="font-heading text-sm font-semibold text-navy">Chat with us</p>
            <button
              onClick={() => setTooltip(false)}
              data-testid="whatsapp-tooltip-close"
              className="text-slate-400 hover:text-slate-600"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="font-body text-xs text-slate-500 mb-3">
            Have questions about admissions or courses? Chat with our team on WhatsApp!
          </p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-tooltip-chat-btn"
            className="block w-full text-center bg-[#25D366] text-white py-2 px-4 font-body text-xs font-semibold uppercase tracking-wider hover:bg-[#1fb855] transition-colors"
          >
            Start Chat
          </a>
        </div>
      )}

      {/* Floating Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-btn"
        className="group relative w-14 h-14 bg-[#25D366] hover:bg-[#1fb855] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
        onMouseEnter={() => setTooltip(true)}
      >
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.132 6.744 3.054 9.378L1.056 31.14l5.944-1.96A15.923 15.923 0 0016.004 32C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.31 22.608c-.39 1.1-1.932 2.014-3.164 2.282-.844.18-1.946.322-5.656-1.216-4.746-1.966-7.8-6.792-8.034-7.108-.226-.316-1.896-2.526-1.896-4.818s1.2-3.42 1.626-3.888c.426-.468.93-.586 1.24-.586.308 0 .618.002.888.016.286.014.668-.108.1044.796.39.938 1.34 3.27 1.458 3.506.118.236.198.512.04.826-.158.316-.236.512-.472.79-.236.276-.496.618-.708.828-.236.236-.482.492-.208.964.276.472 1.226 2.022 2.632 3.276 1.81 1.614 3.336 2.114 3.808 2.35.472.236.748.198 1.024-.118.276-.316 1.18-1.376 1.496-1.848.316-.472.632-.39 1.064-.236.434.158 2.762 1.302 3.234 1.538.472.236.788.354.906.55.118.196.118 1.132-.272 2.232z"/>
        </svg>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-crimson rounded-full border-2 border-white animate-pulse" />
      </a>
    </div>
  );
}
